<script setup lang="ts">
import { inject, ref, watch } from 'vue'

import { t } from '@satch-ui/translations/translations'
import { useBlockScroll } from '@shared/fondof-fn/scroll/useBlockScroll'
import { useCartStore } from '@shared/global-store/stores/cart/cart'
import FloatingCart from '@storefront-satch/components/molecules/floating-cart/FloatingCart.vue'
import { vOnClickOutside } from '@vueuse/components'

import { CartBoldIcon, CartIcon } from '@fond-of/satch-icons'

const showFloatingCart = ref(false)

useBlockScroll(showFloatingCart)

const cartStore = useCartStore()

const setOverlay = inject<((overlay: boolean) => void) | undefined>(
  'setOverlay',
  undefined
)

watch(showFloatingCart, () => setOverlay?.(showFloatingCart.value))
</script>

<template>
  <div>
    <div
      id="metaCart"
      v-on-click-outside="() => (showFloatingCart = false)"
      class="text-gray-medium text-nav h-5.5 group relative z-[301] flex w-fit cursor-pointer items-center text-left transition-all lg:h-full"
      :class="[
        (cartStore.cart?.quantity ?? 0 > 0) ? 'font-sans-medium' : 'font-sans',
      ]"
      @click="showFloatingCart = !showFloatingCart"
    >
      <CartIcon
        class="lg:text-gray-icon w-5.5 h-5.5 block text-black lg:mr-1 lg:hidden lg:h-5 lg:w-3.5"
      />

      <CartBoldIcon
        class="lg:text-gray-icon w-5.5 h-5.5 lg:w-3.75 hidden text-black lg:mr-1 lg:block lg:h-5"
        viewBox="0 0 16 16"
      />

      <span class="text-gray-topnav hidden min-w-fit pt-0.5 lg:inline-flex">
        {{ t('cart.title') }}

        <template v-if="cartStore.cart?.quantity ?? 0 > 0">
          ({{ cartStore.cart?.quantity }})
        </template>
      </span>

      <span
        v-show="cartStore.cart?.quantity ?? 0 > 0"
        id="metaCartQuantity"
        class="text-2xs absolute bottom-0 left-0 top-[0.2rem] flex h-full w-full min-w-max items-center justify-center font-sans text-black lg:hidden"
      >
        {{ cartStore.cart?.quantity ?? 0 }}
      </span>
      <div
        class="pt-4.5 fixed left-0 right-0 top-8 lg:absolute lg:left-auto lg:top-full lg:pt-2"
        :class="{
          hidden: !showFloatingCart,
        }"
        @click.stop
      >
        <FloatingCart
          :cart="cartStore.cart"
          @close="showFloatingCart = false"
        />
      </div>
    </div>
  </div>
</template>
